export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20dramatic%20and%20stylish%20abstract%20composition%20with%20warm%20red%20and%20deep%20crimson%20gradient%20flowing%20shapes%2C%20dark%20mysterious%20background%20with%20soft%20golden%20particles%2C%20cinematic%20atmosphere%2C%20modern%20minimalist%20aesthetic%2C%20luxurious%20dark%20theme%20with%20warm%20accents%2C%20entertainment%20news%20brand%20vibe&width=1600&height=900&seq=hero-bg-51cg&orientation=landscape"
        alt="51cg吃瓜网"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 mb-4 leading-tight">
          51cg吃瓜网
        </h1>
        <p className="text-lg md:text-xl text-background-200 mb-2 font-light">
          51cg.fun黑料吃瓜网 | 最新最全吃瓜资讯平台
        </p>
        <p className="text-sm md:text-base text-background-300 max-w-2xl mx-auto mb-8">
          收录51cg莫里秀全集、找爹视频与51cg爆料内幕，提供51cg黑料合集与情感八卦内容，持续更新中
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="#hot-news"
            className="px-6 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            立即吃瓜
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
          <a
            href="#categories"
            className="px-6 py-3 bg-background-50/10 backdrop-blur-sm text-background-50 rounded-full font-medium text-sm border border-background-50/20 hover:bg-background-50/20 transition-colors cursor-pointer whitespace-nowrap"
          >
            浏览分类
          </a>
        </div>
        <div className="flex items-center justify-center gap-6 mt-10">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-accent-500 font-label">500万+</div>
            <div className="text-xs text-background-300 mt-1">日均活跃用户</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-accent-500 font-label">10万+</div>
            <div className="text-xs text-background-300 mt-1">累计文章数</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-accent-500 font-label">200+</div>
            <div className="text-xs text-background-300 mt-1">合作媒体</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <a href="#hot-news" className="w-10 h-10 bg-background-50/10 rounded-full flex items-center justify-center cursor-pointer hover:bg-background-50/20 transition-colors">
          <i className="ri-arrow-down-line text-background-50"></i>
        </a>
      </div>
    </section>
  );
}